import React from 'react';
import PropTypes from 'prop-types';

import 'assets/scss/subscriptionModal.css';
import SubscriptionModal from './subscriptionModal';

const CancelSubscription = ({
  isVisible,
  toggleModal,
  toggleConfirmCancellation,
}) => {
  return (
    <SubscriptionModal
      isVisible={isVisible}
      toggleModal={toggleModal}
      handleCancel={toggleModal}
      handleConfirm={toggleConfirmCancellation}
      confirmText="Proceed to cancelation"
    >
    <div className="modal-body p-5">
        <h5 className="modal-subtitle text-bold text-left">Cancel Subscription</h5>
        <p className="modal-description text-left mt-3">
          Are you sure you want to cancel the subscription to your Soono account?
          If you cancel your subscription, you will no longer be able to manage
          Surveys, Redemptions.
        </p>
    </div>
    </SubscriptionModal>
  );
};

CancelSubscription.defaultProps = {
  isVisible: false,
  toggleConfirmCancellation: () => {},
};

CancelSubscription.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  toggleConfirmCancellation: PropTypes.func,
};

export default CancelSubscription;



// WEBPACK FOOTER //
// ./src/components/Modal/subscription/cancelSubscription.js